import { render } from "./CotizadorModuls.vue?vue&type=template&id=3bb24196"
import script from "./CotizadorModuls.vue?vue&type=script&lang=js"
export * from "./CotizadorModuls.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__